import AuthApi from '@/services/api/auth-api'

const state = {
  topup: {}
};

const getters = {
  getTopup(state: { topup: any; }) {
    return state.topup;
  }
};

const actions = {

  // FETCH_PROFILE(context: { commit: (arg0: string, arg1: any) => void; }) {
  //   AuthApi.fetchProfile().then((response) => {
  //     //console.log("Resp::", response)
  //     context.commit('SET_PROFILE', response);
  //   });
  // },

};

const mutations = {
  SET_TOPUP(state: { topup: any }, payload: any) {
    state.topup = payload;
  }
};

export default {
  namespace: true,
  state,
  actions,
  mutations,
  getters
};
